
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonSearchCandidateSliderComponent } from '../person-search-candidate-slider/person-search-candidate-slider.component';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { CompanyHoverModalComponent } from '../company-hover-modal/company-hover-modal.component';
import { PersonSearchContactSliderComponent } from '../person-search-contact-slider/person-search-contact-slider.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PersonSearchSimilarSliderComponent } from '../person-search-similar-slider/person-search-similar-slider.component';
import { PersonSearchActivityComponent } from './person-search-activity/person-search-activity.component';
import { AddContactDetailsSliderComponent } from '../add-contact-details-slider/add-contact-details-slider.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatFormFieldControl as MatFormFieldControl } from '@angular/material/form-field';
import { MatRadioModule as MatRadioModule } from '@angular/material/radio';
import {MatProgressBarModule as MatProgressBarModule} from '@angular/material/progress-bar';
import { AiSourcingProfileSliderComponent } from '../ai-sourcing/ai-sourcing-profile-slider/ai-sourcing-profile-slider.component';
import { PersonSearchDocumentSliderComponent } from '../person-search-document-slider/person-search-document-slider.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FusionChartsModule } from 'angular-fusioncharts'; 


@NgModule({
  declarations: [
    PersonSearchCandidateSliderComponent,
    CompanyHoverModalComponent,
    PersonSearchContactSliderComponent,
    PersonSearchSimilarSliderComponent,
    PersonSearchActivityComponent,
    AddContactDetailsSliderComponent,
    AiSourcingProfileSliderComponent,
    PersonSearchDocumentSliderComponent


  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxIntlTelInputModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatRadioModule,
    MatProgressBarModule,
    PdfViewerModule,
    FusionChartsModule
  ],
  exports: [
    PersonSearchCandidateSliderComponent,
    CompanyHoverModalComponent,
    PersonSearchContactSliderComponent,
    PersonSearchActivityComponent,
    PersonSearchDocumentSliderComponent


  ]
})
export class PersonSearchModule { }
